import Query from '../../../components/Report';

const query = new Query('search-stats-countries');

export default query;
